var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z","key":1})]);
}

Upload.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Upload;

Upload.default = Upload;



// WEBPACK FOOTER //
// ./src/images/icons/upload.svg